import { createActionGroup, createFeature, createReducer, createSelector, emptyProps, on } from "@ngrx/store"
import { first } from "rxjs"



export interface EngageObject {
  is_engaged: boolean
  page?:string
  extra_request_data?:any
}

export interface PerformanceLogAction{
  action:'start'|'stop',
  traceName:string
}

export interface UiState {
  engage:EngageObject
  takeover_loading:string
  nav_inc:number
  messages:UiMessage[]
  performanceLog:PerformanceLogAction
  windowBlurred: boolean
  mobileView: boolean
  forceShowMobileMenu: boolean
}

const initialStateCreator = (): UiState => ({
  engage:{
    is_engaged: false,
    page:''
  },
  takeover_loading: '',
  nav_inc: 0,
  messages: [],
  performanceLog:{
    action:null,
    traceName:null
  },
  windowBlurred: true,
  mobileView: false,
  forceShowMobileMenu: false
})

export type MessageAction = "critical" | "account" | "standard"

export interface UiMessage {
  message:string
  type: "message" | "error" | "warn"
  action: MessageAction
  unique_id?:string
  func?:Function
  button_text?:string
  code?:string
  icon?: "problem" | "error" | "warn"
  self?: any;
  meta?: {id: string};
  class?: string
}

export const uiActions = createActionGroup({
  source: 'UI',
  events: {
    'Engage Toggle': (page: string, extra_request_data?:any) => ({ page, extra_request_data }),
    'Engage Reset': emptyProps(),
    'Update UI Item': (key:string, value:string) => ({ key, value }),
    'Add UI Message': (payload: UiMessage, unique_id?:string) => ({ payload, unique_id }),
    'Remove UI Message': (index: number) => ({ index }),
    'Performance Log': (performanceLog: PerformanceLogAction) => ({ performanceLog }),
    'Set Mobile View': (isMobileView: boolean) => ({ isMobileView }),
    'Window Blurred': (payload: boolean) => ({ payload }),
    'Hide Mobile Menu': emptyProps(),
  }
})
export const uiReducer = createReducer(
  initialStateCreator(),
  on(uiActions.engageToggle, (state, {page, extra_request_data}) => ({
    ...state,
    engage: {page, extra_request_data, is_engaged:(state.engage.page !== page || !state.engage.is_engaged)}
  })), 
  on(uiActions.engageReset, (state) => ({
    ...state,
    engage: {...state.engage, is_engaged:false}
  })), 
  on(uiActions.updateUIItem, (state, {key, value}) => ({
    ...state,
    [key]:value
  })), 
  on(uiActions.addUIMessage, (state, {payload, unique_id}) => {
    const messages = [...state.messages]
    if(unique_id) messages[messages.findIndex(m=>m.unique_id===unique_id)] = payload
    else messages.push(payload)
    return {
      ...state,
      messages
    }
  }),
  on(uiActions.removeUIMessage, (state, {index}) => ({
    ...state,
    messages: state.messages.filter((m,i,a)=>i!==index)
  })),
  on(uiActions.performanceLog, (state, {performanceLog}) => ({
    ...state,
    performanceLog: performanceLog
  })),
  on(uiActions.setMobileView, (state, {isMobileView}) => ({
    ...state,
    mobileView: isMobileView
  })),
  on(uiActions.windowBlurred, (state, {payload}) => ({
    ...state,
    windowBlurred: payload
  })),
  on(uiActions.hideMobileMenu, (state) => ({
    ...state,
    forceShowMobileMenu: false
  })),  
);

export const uiFeature = createFeature({
  name: 'ui',
  reducer: uiReducer,
  extraSelectors: ({ selectUiState }) => ({
    selectEngage_is_engaged: createSelector(
      selectUiState,
      (state: UiState) => state.engage.is_engaged
    ),
    selectTakeover_loading: createSelector(
      selectUiState,
      (state: UiState) => state.takeover_loading
    ),
  }),
});


export const getOneStorePromise = (store, selectStatement) => store.pipe(selectStatement, first()).toPromise()
